const fontsColorPrimary = widgetInit.settings.fonts_color_primary
const stepBoxStyles = {
  height: '30px',
  width: '30px',
  borderRadius: '4px',
  border: `solid 1px ${fontsColorPrimary}`,
  padding: '0px 2px',
  fontSize: '16px',
  color: fontsColorPrimary,
  backgroundColor: 'transparent',
}

const Stepper = ({ quantity, maxQuantity, minQuantity, inventoryId, onIncrement, onDecrement, ariaLabel, isDisabled, styleObj }) => {
  const isMinusButtonDisabled = quantity === minQuantity || isDisabled
  const isPlusButtonDisabled = quantity === maxQuantity || isDisabled

  const minusStepBox = {
    ...stepBoxStyles,
    opacity: isMinusButtonDisabled ? '0.3' : '1',
    cursor: isMinusButtonDisabled ? 'not-allowed' : 'pointer',
  }
  const plusStepBox = {
    ...stepBoxStyles,
    opacity: isPlusButtonDisabled ? '0.3' : '1',
    cursor: isPlusButtonDisabled ? 'not-allowed' : 'pointer',
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', userSelect: 'none', ...styleObj }}>
      <button
        type="button"
        style={minusStepBox}
        onClick={event => {
          // Stop click event propagation so that it doesn't collapse the inventory item whenever
          // the minus button is clicked.
          event.stopPropagation()
          if (!isMinusButtonDisabled) {
            onDecrement(inventoryId)
          }
        }}
        aria-label="decrement"
        aria-disabled={isMinusButtonDisabled}
      >
        <span style={{ fontSize: '24px', width: '24px' }} className="fa fa-minus" />
      </button>
      <div
        style={{
          width: '30px',
          margin: '0 3px',
          textAlign: 'center',
          fontWeight: '400',
          fontSize: '14px',
          letterSpacing: '1px',
          color: fontsColorPrimary,
          marginTop: '2px',
          opacity: isDisabled ? '0.3' : '1',
        }}
        aria-label={ariaLabel}
        role="alert"
        data-test="stepper-quantity"
      >
        {quantity}
      </div>
      <button
        type="button"
        style={plusStepBox}
        onClick={event => {
          // Stop click event propagation so that it doesn't collapse the inventory item whenever
          // the plus button is clicked.
          event.stopPropagation()
          if (!isPlusButtonDisabled) {
            onIncrement(inventoryId)
          }
        }}
        aria-label="increment"
        aria-disabled={isPlusButtonDisabled}
      >
        <span style={{ fontSize: '24px', width: '24px' }} className="fa fa-plus" />
      </button>
    </div>
  )
}

export default Stepper
